<template>
	<div class="tabWrapperSettings tabInventory">
		<main-table
				padding="0"
				:flag="flag"
				:headers="getHeaders"
				:listItems="inventoryInventory"
				@updateClickButton="onClickButton($event, flag)"
				:items-per-page-amount="10"
				:pages="[ 10, 20, 50, 100, 200, 500, 'All' ]"
				@updateCreate="onCreate"
				text-create="Add new inventory"
				page-title="Inventory"
				:is-filter-refresh="false"
				:is-export="false"
				:is-search="false"
				:is-create="isCreate()"
		></main-table>

		<view-inventory
				v-if="isViewInventory"
				:dialogFlag="dialogFlag"
				:editInventory="editInventory"
				:items="inventoryInventory"

				@updateSave="onSaveViewInventory"
				@updateClose="onCloseDialog('isViewInventory')"
				@updateList="onUpdateList('inventory')"
		></view-inventory>

		<dialog-remove
				v-if="isDialogRemove"
				:titleRemove="titleRemove"
				:textRemove="textRemove"
				@updateRemove="onRemove"
				@updateCloseRemove="onCloseRemove"
		></dialog-remove>
	</div>
</template>

<script>
import MainTable from "@/shared/MainTable/MainTable.vue";
import { tabInventoryTable, TEXT, TITLE } from "@/pages/Settings/UserAccountSettings/constants";
import ViewInventory from "@/components/Settings/UserAccountSettings/ViewInventory/ViewInventory.vue";
import DialogRemove from "@/shared/DialogRemove/DialogRemove.vue";

import { mapActions, mapGetters } from "vuex";
import { PERMISSIONS, TAB } from "@/constants/constants";
import { getPermissionsMod } from "@/helper/getPermissionsMod";

export default {
	name: "tabInventory",
	components: {
		DialogRemove,
		ViewInventory,
		MainTable
	},
	computed: {
		...mapGetters([
			'editInventory',
			'settingsInventory',
			'inventoryInventory',
			'filtersInventory',
			'permissionsDefault',
		]),
		getHeaders() {
			return tabInventoryTable;
		},
	},

	data: () => ({
		flag: TAB.INVENTORY,

		isViewInventory: false,
		dialogFlag: null,
		nameComponent: null,
		isDialogRemove: false,
		titleRemove: null,
		textRemove: null,
		activeItem: null,
	}),

	methods: {
		...mapActions([
			'getAccountInventoryList',
			'getAccountInventoryEdit',
			'deleteAccountInventory',
		]),

		isCreate() {
			const list = this.permissionsDefault;
			const path = [ PERMISSIONS.SETTINGS, PERMISSIONS.USER_ACCOUNT_SETTINGS, PERMISSIONS.U_A_S_INVENTORY, PERMISSIONS.CREATE ];
			return getPermissionsMod({ list, path });
		},
		async onUpdateList(key) {
			if (key === 'inventory') {
				await this.getAccountInventoryList();
			}
		},

		onClickButton({ key, item }, nameComponent) {
			this.dialogFlag = 'edit';
			this.nameComponent = nameComponent;
			this.activeItem = item;

			if (nameComponent === 'tabInventory' && key === 'edit1') {
				this.accountInventoryEdit();
			}
			if (nameComponent === 'tabInventory' && key === 'delete1') {
				const title = TITLE.REMOVE_INVENTORY;
				const text = TEXT.REMOVE_INVENTORY;
				this.onRemoveDialog({ title, text });
			}
		},
		async onRemove() {
			if (this.nameComponent === 'tabInventory') {
				const { id } = this.activeItem;
				await this.deleteAccountInventory(id);
				this.onCloseRemove();
			}
		},
		onRemoveDialog(args) {
			const { title, text } = args;
			this.titleRemove = title;
			this.textRemove = text;
			this.isDialogRemove = true;
		},
		onCloseRemove() {
			this.isDialogRemove = false;
		},
		async accountInventoryEdit() {
			const { id } = this.activeItem;
			await this.getAccountInventoryEdit(id);
			this.isViewInventory = true;
		},
		onCreate() {
			this.dialogFlag = 'add';
			this.isViewInventory = true;
		},
		onSaveViewInventory(args) {
			console.info('%c [ onSaveViewInventory args  ] ', 'color:#bada55', typeof args, args );
		},
		onCloseDialog(key) {
			this[key] = false;
		},
	},
	async mounted() {
		await this.getAccountInventoryList();
	}
};
</script>

<style scoped lang="scss">
@import "tabWrapperSettings";
</style>

